import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "element-loading-text": "表单加载中",
  style: {"height":"100px"}
}
const _hoisted_2 = ["src", "height"]

import { getCloudHtmlFormDataId, onetThingFormSave } from "@/config/request";
import { ElMessage } from "element-plus";
import { nextTick, reactive, toRefs } from "vue";
import Nav from "./nav.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData: Object
},
  setup(__props, { expose: __expose }) {

const props = __props
const data = reactive({
    height: '800',
    loading: true,
})
const { publicData } = toRefs(props) as any

const check = async() => {
    let status = 200
    let params = {
        projid: publicData.value.basicInfo.preApasinfo.projid,
        formId: publicData.value.formJson.formId
    }
    let res = await getCloudHtmlFormDataId(params) as any
    console.log('是否提交表单返回值res',res);

    if(res.success){
        //赋值云表单id
        publicData.value.basicInfo.preApasinfoRelation.formUnid = res.result.id;
        publicData.value.jmFormData = res.result.jmFormData
        let paramsform = {
            "formDataid": publicData.value.basicInfo.preApasinfoRelation.formUnid,
            "formUnid": publicData.value.formJson.formId,
            "oneThingUnid": publicData.value.basicInfo.preApasinfo.projid
        }
        let res2 = await onetThingFormSave(paramsform) as any
        console.log('是否提交表单返回值res2',res2);
        if(res2.code === 200){
            ElMessage.success('保存表单关联信息成功');
        }else{
            ElMessage.error('保存表单关联信息失败');
            status = 500
        }
    } else {
        ElMessage.error("请先提交表单!");
        status = 500
    }
    let result = {
        data: publicData.value,
        status: status
    }
    return result
}
__expose({
    check
})
nextTick(() => {
    const iframe = document.getElementById('iframe') as any
    iframe.onload = function () {
        data.loading = false
    };
}) 
/* nextTick(() => {
    const iframe = document.getElementById('iframe') as any
    iframe.onload = function () {
        let height = iframe.ownerDocument.body.clientHeight - 200
        console.log('height',height);
        data.height = height + 'px'
        data.loading = false
    };
}) */


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_title_h2" }, "表单信息", -1)),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
        [_directive_loading, data.loading],
        [_vShow, data.loading]
      ]),
      _createElementVNode("iframe", {
        src: _unref(publicData).formUrl,
        frameborder: "0",
        width: "100%",
        height: data.height,
        id: "iframe"
      }, null, 8, _hoisted_2)
    ])
  ], 64))
}
}

})